// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"125":"b8bb3b97","161":"355ccca9","703":"704dae1c","960":"3f3d93a2","989":"b0196eb2"}[chunkId] + ".chunk.css";
};